// extracted by mini-css-extract-plugin
export default {"bg":"c7cMWz","inlineContent":"FVGvCX","pageWrapper":"zK7MhX","root":"fEm0Bo"};